<template>
  <v-select
    v-model="modelValue"
    :items="PERIPHERAL_EQUIPMENT_LIST"
    item-title="name"
    item-value="value"
    :label="i18n.global.t('pages.vehicles.peripheralEquipment')"
    multiple
    chips
  ></v-select>
</template>

<script setup lang='ts'>
import { computed } from 'vue';
import i18n from '@/lang/i18n';
import { PERIPHERAL_EQUIPMENT_LIST } from '@/services/consts/vehicle'

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: Record<string, boolean>
}>()

const modelValue = computed({
  get() {
    return convertSelectedItemsObjectToArray(props.modelValue);
  },
  set(value) {
    emit('update:modelValue', convertSelectedItemsArrayToObject(value));
  },
});

const convertSelectedItemsObjectToArray = (objectItems: Record<string, boolean>) => {
  let arrayItems = [] as string[]
  if (objectItems) {
    Object.keys(objectItems).forEach((key: string) => {
      if (objectItems[key] === true) {
        arrayItems.push(key)
      }
    })
  }

  return arrayItems
}

const convertSelectedItemsArrayToObject = (arrayItems: string[]) => {
  const objectItems = {
    enabledCameraFront: false,
    enabledCameraRear: false,
    enabledCameraInner: false,
    enabledCameraSide: false,
    enabledTdsensorCh1: false,
    enabledTdsensorCh2: false,
    enabledTdsensorCh3: false,
    enabledTdsensorCh4: false,
    enabledEtc: false,
  } as Record<string, boolean>

  arrayItems.forEach((item: string) => {
    objectItems[item] = true
  })

  return objectItems
}

</script>
